export const landingCopy = {
  hero: {
    brand: '[FLOWQA]',
    headline: 'Test Results Tooling For Modern Teams.',
    subheading: 'Cut through the noise. Save time. Get insights.',
    primaryCta: 'Sign Up For Free',
    secondaryCta: 'Example Project',
  },
  testingChanged: {
    sectionTitles: {
      awareness: 'How Much Do You Really Know About Your Tests?',
      struggles: 'Teams Struggle With:',
      conclusion: 'The Results Data Already Exists - Why Not Use It?',
    },
    awarenessParagraphs: [
      "Tests are a non-negotiable part of software development, but testing often only gives a one-time snapshot into software quality whether it's through manual regression runs or automated pipeline executions.",
      'Code output is up, tests are auto-generated, but our understanding of quality struggles to keep up.',
    ],
    bullets: [
      'Knowing what tests are run for your features, and where (and when)',
      'Stretched or limited QA capacity, feeling the pressure tracking multiple projects at once',
      'Outdated spreadsheets with custom formulae and ad-hoc reports that take hours to maintain',
      "Identifying the patterns that's causing their build pipelines to fail (it's always that one test)",
      'Not having the clear data to back up quality concerns, or to highlight success over time',
    ],
  },
  flowSteps: [
    {
      title: 'Run Your Tests',
      bullets: [
        'Run your tests as normal',
        'Record the results',
        '.xlsx, .csv, .xml, .json - your choice',
      ],
    },
    {
      title: 'Upload The Results',
      bullets: [
        'Upload the data to FlowQA',
        'Manually, via terminal, or during your pipeline',
        "We'll parse and aggregate the important bits",
      ],
    },
    {
      title: 'Gain Insights',
      bullets: [
        'Track test metrics across projects in one place',
        'Search, filter, and find insights about your suites, tests, and pipelines',
      ],
    },
  ],
  qualityHighlights: {
    heading: 'Track Quality Over Time',
    intro:
      'Trace status and metric trends and changes, with customisable thresholds to keep your team on-track.',
  },
  featurePanels: [
    {
      title: 'Track quality trends',
      items: ['Understand how pass rates and test stability evolve across executions.'],
    },
    {
      title: 'Understand what changed',
      items: ['Compare recent runs with historical performance to identify regressions quickly.'],
    },
    {
      title: 'Centralise results',
      items: ['Bring together results from multiple pipelines, projects, or manual test cycles.'],
    },
    {
      title: 'Focus your effort',
      items: ['Spend less time interpreting reports and more time improving tests.'],
    },
  ],
  executionTables: {
    heading: 'Drill Down Into The Details',
    intro:
      "Easily track every suite, test and pipeline's latest stats, and historical performance.",
  },
} as const;
